document.addEventListener('DOMContentLoaded', function() {
  
  var modal = document.getElementById('modal');
  var modal_overlay = document.getElementById('modal-overlay');
  var closeModal = document.getElementById('close-modal');

  var modalImage = document.getElementById('modal-image');
  var modalDescription = document.getElementById('modal-description');

  var lifetimeWarranty = document.getElementById('lifetime-warranty');
  var lifetimeUpgrade = document.getElementById('lifetime-upgrade');
  var fiveyearWarranty = document.getElementById('fiveyear-warranty');
  var watchlifetimeUpgrade = document.getElementById('watch-lifetime-upgrade');

  if(fiveyearWarranty){
    fiveyearWarranty.addEventListener('click', function() {
    modal.style.display = "block";
    modal_overlay.style.display = "block";
    modalImage.src = "https://cdn.shopify.com/s/files/1/1117/3536/files/IMG-20250116-WA0008.jpg?v=1737023972";
    modalDescription.textContent = "Watches purchased from Frost NYC are backed by our 5 year warranty, the most in the industry. So rest assured, your watch will stand the test of time.";
  });
  }
  
  if(lifetimeWarranty){
    lifetimeWarranty.addEventListener('click', function() {
    modal.style.display = "block";
    modal_overlay.style.display = "block";
    modalImage.src = "https://cdn.shopify.com/s/files/1/1117/3536/files/1000180387.jpg?v=1736873832";
    modalDescription.textContent = "Take the risk out of your purchase. All jewelry comes with lifetime warranty and all Rolex watches comes with a 5 year warranty.";
  });
  }

  if(lifetimeUpgrade){
  lifetimeUpgrade.addEventListener('click', function() {
    modal.style.display = "block";
    modal_overlay.style.display = "block";
    modalImage.src = "https://cdn.shopify.com/s/files/1/0063/6741/2260/files/Lifetime_Upgrade_Arrow.png?v=1713195565";
    modalDescription.textContent = "Never lose money on jewelry ever again. We will take back your jewelry at full purchase price on anything 2x higher priced. Just pay the difference.";
  });
  }

  if(watchlifetimeUpgrade){
    watchlifetimeUpgrade.addEventListener('click', function() {
    modal.style.display = "block";
    modal_overlay.style.display = "block";
    modalImage.src = "https://cdn.shopify.com/s/files/1/1117/3536/files/Watches_lifetime_upgrade.jpg?v=1737269500";
    modalDescription.textContent = "Never lose money on jewelry ever again. We will take back your jewelry at full purchase price on anything 2x higher priced. Just pay the difference.";
  });
  }

  if(closeModal){
  closeModal.addEventListener('click', function() {
    modal.style.display = "none";
    modal_overlay.style.display = "none";
  });
  }

  if(modal_overlay){
    modal_overlay.addEventListener('click', function() {
    modal_overlay.style.display = "none";
    modal.style.display = "none";
  });
  }

  window.addEventListener('click', function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      modal_overlay.style.display = "none";
    }
  });

});